import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TimelineIcon from '@mui/icons-material/Timeline';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import TextOrCall from '../../TextOrCall';

interface BuyerOfferSuccessProps {
  propertyAddress?: string;
  finalReview?: boolean;
}

const BuyerOfferSuccess: React.FC<BuyerOfferSuccessProps> = ({
  propertyAddress,
  finalReview = false,
}) => {
  return (
    <Box sx={{ textAlign: 'center', py: 4, px: 3 }}>
      <CheckCircleIcon
        sx={{
          fontSize: 64,
          color: 'success.main',
          mb: 2,
        }}
      />

      <Typography variant="h5" component="h2" gutterBottom>
        {finalReview
          ? 'Thank you for signing your offer!'
          : 'Your offer has been submitted successfully!'}
      </Typography>

      {propertyAddress && (
        <Typography variant="body1" color="text.secondary" gutterBottom>
          for {propertyAddress}
        </Typography>
      )}

      <Box sx={{ bgcolor: 'background.default', p: 3, mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          What happens next?
        </Typography>

        {finalReview ? (
          <Stack spacing={3} sx={{ mt: 2 }} alignItems={'center'}>
            <Stack direction={'row'} alignItems={'center'} spacing={2}>
              <TimelineIcon sx={{ color: 'primary.main', mb: 1 }} />
              <Typography variant="body1" gutterBottom>
                Your offer has been sent to the seller for review.
              </Typography>
            </Stack>

            <Stack direction={'row'} alignItems={'center'} spacing={2}>
              <PhoneIcon sx={{ color: 'primary.main', mb: 1 }} />
              <Typography variant="body1">
                A Homepoint representative will keep you updated on the
                seller&apos;s response.
              </Typography>
            </Stack>

            <Stack direction={'row'} alignItems={'center'} spacing={2}>
              <EmailIcon sx={{ color: 'primary.main', mb: 1 }} />
              <Typography variant="body1" gutterBottom>
                You&apos;ll receive a notification when the seller responds to
                your offer.
              </Typography>
            </Stack>
          </Stack>
        ) : (
          <Stack spacing={3} sx={{ mt: 2 }} alignItems={'center'}>
            <Stack direction={'row'} alignItems={'center'} spacing={2}>
              <TimelineIcon sx={{ color: 'primary.main', mb: 1 }} />
              <Typography variant="body1" gutterBottom>
                Homepoint will review your offer within a few hours.
              </Typography>
            </Stack>

            <Stack direction={'row'} alignItems={'center'} spacing={2}>
              <PhoneIcon sx={{ color: 'primary.main', mb: 1 }} />
              <Typography variant="body1">
                A Homepoint representative will contact you to discuss the
                offer.
              </Typography>
            </Stack>

            <Stack direction={'row'} alignItems={'center'} spacing={2}>
              <EmailIcon sx={{ color: 'primary.main', mb: 1 }} />
              <Typography variant="body1" gutterBottom>
                You&apos;ll receive a notification once the offer is approved
                and ready for you to sign.
              </Typography>
            </Stack>
          </Stack>
        )}
      </Box>

      <Stack
        direction={'row'}
        justifyContent={'center'}
        spacing={2}
        sx={{ mt: 4 }}
        alignItems={'center'}
      >
        <Typography variant="body2">Have questions?</Typography>
        <TextOrCall />
      </Stack>
    </Box>
  );
};

export default BuyerOfferSuccess;
